import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

// Model
import { ResponseBase } from '../models/response-base';
import { CedenteContrato } from '../models/cedente-contrato';
import { CedenteContratoCadastro } from '../models/cedente-contrato-cadastro';
import { AssociarQRCodeRequest } from '../models/AssociarQRCodeRequest';
import { CarregarCartaoRequest } from '../models/CarregarCartaoRequest';
import { AssociateCardModel } from '../models/associate-card-model';
import { ContractAssignor, Product, UpdateContractAssignor } from '../models/contract-assignor';

@Injectable({
    providedIn: 'root'
})
export class ContratoService {

    constructor(private http: HttpClient) { }

    API: string = environment.API + 'Portal/contratos';
    private URL = environment.GATEWAY;

    add(produtoElegibilidadeId: number, cedenteGuid: string): Observable<ResponseBase<CedenteContrato>> {
        return this.http.post<ResponseBase<CedenteContrato>>(`${this.API}/cedentes/${cedenteGuid}`, produtoElegibilidadeId);
    }

    getAll(cedenteGuid: string, categoria: number = 0): Observable<ResponseBase<CedenteContrato[]>> {
        let params = new HttpParams();
        params = params.append('categoria', categoria.toString());
        return this.http.get<ResponseBase<CedenteContrato[]>>(`${this.API}/cedentes/${cedenteGuid}`,{ params });
    }

    update(cedenteContratoId: number, cedenteGuid: string, cedenteContratoCadastro: CedenteContratoCadastro): Observable<ResponseBase<CedenteContrato>> {
        return this.http.put<ResponseBase<CedenteContrato>>(`${this.API}/${cedenteContratoId}/cedentes/${cedenteGuid}`, cedenteContratoCadastro);
    }

    getValorPadrao(cedenteGuid: string, produtoId: number): Observable<ResponseBase<CedenteContrato>> {
        return this.http.get<ResponseBase<CedenteContrato>>(`${this.API}/valor-padrao/${cedenteGuid}/${produtoId}`);
    }

    CadastrarQRCode(associarQRCodeRequest: AssociarQRCodeRequest): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${environment.API}Transaction/qrcode/associar`, associarQRCodeRequest);
    }

    CarregarCartao(carregarCartaoRequest: CarregarCartaoRequest): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${environment.API}Transaction/qrcode/recarregar`, carregarCartaoRequest);
    }

    ValidaSeExisteContaSeuValeSocial(cedenteGuid: string, colaboradorID: number): Observable<ResponseBase<string>> {
        return this.http.get<ResponseBase<string>>(`${this.API}/conta/${cedenteGuid}/${colaboradorID}`);
    }

    CancelarProduto(cedenteGuid: string, produtoElegibilidadeId: number): Observable<ResponseBase<any>> {
        return this.http.delete<ResponseBase<string>>(`${this.API}/cancelar/${cedenteGuid}/produto/${produtoElegibilidadeId}`);
    }

    cardToColaborator(associateCardModel: AssociateCardModel): Observable<ResponseBase<boolean>> {
        return this.http.post<ResponseBase<boolean>>(`${environment.API}Transaction/cartao/associar`, associateCardModel);
    }

    ValidaSeTemQRCode(cedenteGuid: string, colaboradorID: number): Observable<ResponseBase<string>> {
        return this.http.get<ResponseBase<string>>(`${this.API}/qrcode/${cedenteGuid}/${colaboradorID}`);
    }

    createContract(produtoElegibilidadeId: number, cedenteGuid: string): Observable<ResponseBase<ContractAssignor>> {
        return this.http.post<ResponseBase<ContractAssignor>>(`${this.URL}product/contracts/assignors/${cedenteGuid}`, produtoElegibilidadeId);
    }

    getContracts(cedenteGuid: string, categoria: number = 0): Observable<ResponseBase<ContractAssignor[]>> {
        let params = new HttpParams();
        params = params.append('category', categoria.toString());
        return this.http.get<ResponseBase<ContractAssignor[]>>(`${this.URL}product/contracts/assignors/${cedenteGuid}`,{ params });
    }

    cancelContract(cedenteGuid: string, categoria: number = 0): Observable<ResponseBase<CedenteContrato[]>> {
        let params = new HttpParams();
        params = params.append('categoria', categoria.toString());
        return this.http.delete<ResponseBase<CedenteContrato[]>>(`${this.URL}product/contracts/assignors/${cedenteGuid}`,{ params });
    }

    updateContract(cedenteContratoId: number, cedenteGuid: string, updateContractAssignor: UpdateContractAssignor): Observable<ResponseBase<ContractAssignor>> {
        return this.http.put<ResponseBase<ContractAssignor>>(`${this.URL}product/contracts/${cedenteContratoId}/assignors/${cedenteGuid}`, updateContractAssignor);
    }
    
    getContractsAssignorProducts(cedenteGuid: string): Observable<ResponseBase<Product[]>> {
        return this.http.get<ResponseBase<Product[]>>(`${this.URL}product/contracts/products/assignors/${cedenteGuid}`);
    }
}
